import { Pencil, Trash2 } from 'lucide-react';

function formatCellValue(field, item) {
  if (field.type === 'boolean') {
    return item[field.key] ? 'Yes' : 'No';
  }
  return item[field.key] || '-';
}

export default function CrudTable({ data, displayFields, onEdit, onDelete }) {
  if (data.length === 0) {
    return (
      <div className="w-full overflow-x-auto rounded-lg border border-[#1c2a3d]">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr>
              {displayFields.map(f => (
                <th key={f.key} className="bg-[#1c2a3d] text-[#a3b1c6] font-medium p-4 border-b border-[#1c2a3d] text-sm">{f.label}</th>
              ))}
              <th className="bg-[#1c2a3d] text-[#a3b1c6] font-medium p-4 border-b border-[#1c2a3d] text-sm w-24">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colSpan={displayFields.length + 1} className="p-8 text-center text-[#a3b1c6]">No items yet</td></tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto rounded-lg border border-[#1c2a3d]">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr>
            {displayFields.map(f => (
              <th key={f.key} className="bg-[#1c2a3d] text-[#a3b1c6] font-medium p-4 border-b border-[#1c2a3d] text-sm">{f.label}</th>
            ))}
            <th className="bg-[#1c2a3d] text-[#a3b1c6] font-medium p-4 border-b border-[#1c2a3d] text-sm w-24">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.id} className="hover:bg-[#1c2a3d]/50 transition-colors" data-testid={`admin-row-${item.id}`}>
              {displayFields.map(f => (
                <td key={f.key} className="p-4 border-b border-[#1c2a3d] text-[#fdfbf7] text-sm max-w-xs truncate">
                  {formatCellValue(f, item)}
                </td>
              ))}
              <td className="p-4 border-b border-[#1c2a3d]">
                <div className="flex items-center gap-2">
                  <button data-testid={`admin-edit-${item.id}`} onClick={() => onEdit(item)} className="text-[#a3b1c6] hover:text-[#d4af37] transition-colors">
                    <Pencil className="w-4 h-4" />
                  </button>
                  <button data-testid={`admin-delete-${item.id}`} onClick={() => onDelete(item.id)} className="text-[#a3b1c6] hover:text-red-400 transition-colors">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
